import { Component, Input, EventEmitter, Output } from '@angular/core';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import {
  type CalculateComponentRendering,
  CalculateComponentContent,
} from '@innogy/become-a-customer/shared/interfaces';
import type { TypedComponentRendering } from '@core/jss-models';
import type { ComponentFields } from '@sitecore-jss/sitecore-jss-angular';
import { FormGroupControls, FormGroupState } from 'ngrx-forms';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { CommonModule } from '@angular/common';
import { provideBootstrapEffects } from '@innogy/utils-state';

import { BacUsageQuestionnaireModalEffects } from '../../usage-questionnaire-sme-modal/state/bac-usage-questionnaire-modal.effects';

@Component({
  selector: 'wl-calculate-form-questionnaire-trigger',
  templateUrl: './calculate-form-questionnaire-trigger.component.html',
  standalone: true,
  imports: [CommonModule, CommonUiUtilityComponentsModule],
  providers: [provideBootstrapEffects([BacUsageQuestionnaireModalEffects])],
})
export class CalculateFormQuestionnaireTriggerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState?: FormGroupState<FullCalculateFormValues>;
  @Output()
  public calculateOpenModal = new EventEmitter<any>();
  @Output()
  public setQuestionnaireContainerVisibility = new EventEmitter<boolean>();

  get fields(): ComponentFields | undefined {
    return this.rendering?.fields;
  }
}
